import PropTypes from 'prop-types';
import i18n from '@wix/wix-vod-shared/src/common/i18n';

import BackIcon from './back.svg';

import styles from './styles.styl';
import translations from 'messages/widget';

const Header = ({ dataHook, onBackButtonClick }) => (
  <div data-hook={dataHook}
       className={styles.title}>
    <a href="#"
       data-hook="back-button"
       className={styles['back-button']}
       onClick={onBackButtonClick}
       aria-label={i18n.t(translations.closeEmbedForm)}>
      <BackIcon />
    </a>

    <span className={styles['title-text']}>
      {i18n.t(translations.embedTitle)}
    </span>
  </div>
);

Header.propTypes = {
  dataHook: PropTypes.string,
  onBackButtonClick: PropTypes.func,
};

export default Header;



// WEBPACK FOOTER //
// ./src/widget/containers/share-overlay/embed-form/header/header.js